import { logUsage } from 'owa-analytics';

/** Log telemetry data when a Focus Time event is saved */
export default function logSaveFocusTimeEvents(eventMetricProperties: any) {
    let entrySource = 'Other';
    if (eventMetricProperties.EntrySource == 'FocusTimeSuggestion') {
        entrySource = 'FocusTimeSuggestion';
    }
    let isTimeChanged = false;
    if (
        eventMetricProperties.hasOwnProperty('StartTimeSet') &&
        eventMetricProperties.hasOwnProperty('EndTimeSet')
    ) {
        isTimeChanged =
            eventMetricProperties['StartTimeSet'] || eventMetricProperties['EndTimeSet'];
    }
    const customData = {
        sourceType_1: entrySource,
        isNewEvent_2: eventMetricProperties.IsNewEvent,
        timeOfDayActionTaken_3: eventMetricProperties.TimeOfDayActionTaken,
        isTimeChanged_4: isTimeChanged,
    };
    logUsage('SaveFocusTimeEvent', customData, { isCore: true });
}
